export default __webpack_public_path__ + "static/media/yash.5e697369.jpg";